import React, { useState, useContext, useEffect, useRef } from "react";
import "./supportGroupTabs.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import GlobalContext from "../../../contexts/globalContext";
import Button from "../../atoms/button/button";
// import JoinModal from "../join-modal/joinModal";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { userServices } from "../../../services/backServices";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import Loading from "../../atoms/loading/loading";
import { isUserAllowedToEnter } from "../../../utils/ScheduleDateFormat";
import { openNotification } from "../../../utils/OpenNotification";
const setting = {
  dots: false,
  arrows: false,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  initialSlide: 0,
};

const SupportGroupTabs = (props: ReferenciaContenido) => {
  const data = props;
  const [activeTab, setActiveTab] = useState(0);
  const [isJoinOpen, setIsJoinOpen] = useState(false);
  const [isLeaveOpen, setIsLeaveOpen] = useState(false);
  const [isMsgExpanded, setIsMsgExpanded] = useState(false);
  const globalContext = useContext(GlobalContext);
  const [userGroupData, setUserGroupData] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [commerceData, setCommerceData] = useState([]);
  const [remove, setRemove] = useState(false);
  // const dataContext = useContext(GlobalContext);

  const [refBtn] = useState(useRef());

  const reloadData = () => {
    setCommerceData([]);
    setUserGroupData([]);
    setLoaded(false);
    setRemove(!remove);
  };

  useEffect(() => {
    if (!loaded && globalContext.userInfoContext.data?.userJwt) {
      userServices
        .getUserGroupEvents(
          globalContext?.userInfoContext?.data?.userJwt,
          globalContext?.userInfoContext?.data?.userEmail
        )
        .then((res) => {
          setLoaded(true);
          setCommerceData(res?.data?.data?.listGroupApp);
          // test for overdue appointments

          let overdueList =
            res.data.data?.responseTransGroupServiceUserList?.body?.data
              ?.overdueAppointments;

          if (overdueList && overdueList.length != 0) {
            let lastEvent = overdueList[overdueList.length - 1];
            // test if time is between startDate and startDate + duration
            let startDate = new Date(lastEvent.startDate);
            let endDate = new Date(lastEvent.until);

            //console.log(compareDatesLog(new Date(lastEvent.startDate), 15));
            // user can enter the event even when it already started
            if (isUserAllowedToEnter(startDate, endDate)) {
              setUserGroupData(overdueList.slice(-1));
              return;
            }
          }

          if (
            res.data.data?.responseTransGroupServiceUserList?.body?.data
              ?.upcomingCloseAppointments?.length != 0
          ) {
            setUserGroupData(
              res.data.data?.responseTransGroupServiceUserList?.body?.data
                ?.upcomingCloseAppointments
            );
          } else if (
            res.data.data?.responseTransGroupServiceUserList.body.data
              .upcomingAppointments.length != 0
          ) {
            setUserGroupData(
              res.data.data?.responseTransGroupServiceUserList?.body?.data
                ?.upcomingAppointments
            );
          }
        });
    } else {
      setUserGroupData([]);
    }
  }, [globalContext.userInfoContext, remove]);

  const getDescripcionEventos = (idx) => {
    return JSON.parse(
      data?.referenciaTabsContenido[activeTab]?.referenciaCursosDestacados[0]
        ?.descripcionEvento?.raw
    )?.content[0]?.content[idx];
  };

  const hasGroup = () => {
    return userGroupData?.length > 0;
  };

  const handleGo = async () => {
    setLoading(true);
    const request = await userServices.validateGroupEvent(
      globalContext.userInfoContext.data?.userJwt,
      userGroupData[0]?.id
    );
    if (!request.data.data.isValid) {
      openNotification(
        "error",
        "Error",
        "Lo sentimos, el pago no ha sido validado"
      );
    } else {
      if (
        request.data.status === 200 &&
        userGroupData[0].meetingState != null
      ) {
        refBtn.current.click();
      } else {
        openNotification(
          "info",
          "Información",
          "El profesional no ha iniciado la reunión, intenta nuevamente en unos minutos"
        );
      }
    }
    setLoading(false);
  };
  // let uriEstresAnsiedad = `${process.env.URL_TIENDA_COMFAMA}/comfama/es/c/Grupo-de-apoyo-estrés-y-ansiedad-virtual/p/S410002221660`;
  // let encodedEstresAnsiedad = encodeURIComponent(uriEstresAnsiedad);

  // let uriEducandoJovenes = `${process.env.URL_TIENDA_COMFAMA}comfama/es/c/Grupo-de-apoyo-educando-jóvenes-virtual/p/S410002211660`
  // let encodedEducandoJovenes = encodeURIComponent(uriEducandoJovenes);

  const goToShop = () => {
    if (
      data?.referenciaTabsContenido[activeTab]?.nombreTab ==
      " Estrés y ansiedad"
    ) {
      // redireccion para productos tienda
      // window.location.href(encodedEstresAnsiedad || "");
      window.location.assign(
        "https://tienda.comfama.com/comfama/es/Salud-y-Cuidado/Salud-mental/Grupo-de-apoyo-estr%C3%A9s-y-ansiedad-virtual/p/41000222"
      );
    } else if (
      data?.referenciaTabsContenido[activeTab]?.nombreTab == "Educando jóvenes"
    ) {
      // window.location.assign(encodedEducandoJovenes || "");
      window.location.assign(
        "https://tienda.comfama.com/comfama/es/Salud-y-Cuidado/Salud-mental/Grupo-de-apoyo-educando-j%C3%B3venes-virtual/p/41000221"
      );
    } else {
      openNotification("info", "Información", "Problemas??");
    }
  };

  const renderSchedule = () => {
    if (!loaded) {
      return <Loading />;
    }
    return hasGroup() ? (
      <div className="m-support-g-tabs__col2__group-schedule">
        <div className="m-support-g-tabs__col2__group-schedule__info">
          <i className="icon-clock1"></i>
          <div className="m-support-g-tabs__col2__group-schedule__info__txt">
            {/* <h3>{`Próxima sesión | ${userGroupData[0]?.serviceName}`}</h3>
            <p>{formatDate(userGroupData[0]?.startDate)}</p> */}
            <p>hola</p>
            <div
              onClick={() => {
                setIsLeaveOpen(true);
              }}
            >
              <p>salir del grupo</p>
            </div>
          </div>
        </div>
        <div className="m-support-g-tabs__col2__group-schedule__btn">
          {isUserAllowedToEnter(
            new Date(userGroupData[0]?.startDate),
            new Date(userGroupData[0]?.until)
          ) ? (
            <Button
              text={"Ingresar"}
              classname={"a-button primary l-large"}
              type={"button"}
              isDisabled={false}
              strictCss={false}
              gtmMark={"gtmInternaGruposApoyoIngresar"}
              href={""}
              onClickAction={handleGo}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    ) : (
      <div className="m-support-g-tabs__col2__info">
        <i className="icon-clock1"></i>
        <div className="m-support-g-tabs__col2__info__text">
          <h3>{getDescripcionEventos(0)?.content[0]?.content[0]?.value}</h3>
          <p>{getDescripcionEventos(0)?.content[0]?.content[1]?.value}</p>
        </div>
      </div>
    );
  };
  return (
    <div className="m-support-g-tabs">
      {/* <LeaveModal
        isOpen={isLeaveOpen}
        setIsOpen={setIsLeaveOpen}
        jwt={globalContext.userInfoContext.data?.userJwt}
        timifyId={hasGroup() && userGroupData[0]?.id}
        email={hasGroup() && userGroupData[0]?.customerEmail}
        setLoading={setLoading}
        reloadData={reloadData}
      />
      {loading && <LoadingPage />} */}
      <div className="m-support-g-tabs__summary">
        <div className="m-support-g-tabs__summary__title">
          <h2>{data?.tituloGeneral}</h2>
        </div>
        <div className="m-support-g-tabs__summary__description">
          <p>
            {JSON.parse(data?.descripcion?.raw)?.content[0]?.content[0]?.value}
          </p>
        </div>
        <div className="m-support-g-tabs__summary__tabs-container">
          <div className="m-support-g-tabs__summary__tabs-container__tabs">
            <Slider {...setting}>
              {data.referenciaTabsContenido.map((val, idx) => {
                return (
                  <button
                    key={idx}
                    className={`m-support-g-tabs__summary__tabs-container__tabs__btn 
                                                    ${
                                                      activeTab === idx
                                                        ? "m-support-g-tabs__summary__tabs-container__tabs__btn--active"
                                                        : ""
                                                    }`}
                    onClick={() => {
                      setActiveTab(idx);
                    }}
                  >
                    <div>
                      <p>{val?.nombreTab}</p>
                    </div>
                  </button>
                );
              })}
            </Slider>
          </div>
        </div>
      </div>
      <div className="m-support-g-tabs__columns">
        <div className="m-support-g-tabs__col1">
          <div className="m-support-g-tabs__col1__title">
            <h3>
              {
                JSON.parse(
                  data?.referenciaTabsContenido[activeTab]?.descripcion?.raw
                )?.content[0]?.content[0]?.value
              }
            </h3>
          </div>
          <div className="m-support-g-tabs__col1__description">
            <p>
              {
                JSON.parse(
                  data?.referenciaTabsContenido[activeTab]?.descripcion?.raw
                )?.content[1]?.content[0]?.content[0]?.content[0]?.value
              }
            </p>
          </div>
          <div className="m-support-g-tabs__col1__sessions-title">
            <h3>
              {
                data?.referenciaTabsContenido[activeTab]
                  ?.referenciaCursosDestacados[0]?.tituloPrincipal
              }
            </h3>
          </div>
          <div className="m-support-g-tabs__col1__sessions-container">
            {documentToReactComponents(
              JSON.parse(
                data?.referenciaTabsContenido?.[activeTab]
                  ?.referenciaCursosDestacados?.[0]?.descripcion?.raw
              )
            )}
          </div>
          <div className="m-support-g-tabs__col1__moderator">
            <div className="m-support-g-tabs__col1__moderator__label">
              <h3>Moderador</h3>
            </div>
            <div className="m-support-g-tabs__col1__moderator__bio">
              <div className="m-support-g-tabs__col1__moderator__bio__img">
                <img
                  src={
                    data?.referenciaTabsContenido[activeTab]
                      ?.referenciaCursosDestacados[0]?.imagenPrincipal?.file
                      ?.url
                  }
                  alt={
                    data?.referenciaTabsContenido[activeTab]
                      ?.referenciaCursosDestacados[0]?.imagenPrincipal?.title ||
                    "imagen-perfil-moderador"
                  }
                />
              </div>

              <div className="m-support-g-tabs__col1__moderator__bio__container">
                <div className="m-support-g-tabs__col1__moderator__bio__container__name">
                  <h3>
                    {
                      data?.referenciaTabsContenido[activeTab]
                        ?.referenciaCursosDestacados[0]?.nombreModerador
                    }
                  </h3>
                </div>
                <div className="m-support-g-tabs__col1__moderator__bio__container__description">
                  <p>
                    {
                      data?.referenciaTabsContenido[activeTab]
                        ?.referenciaCursosDestacados[0]?.fraseModerador
                    }
                  </p>
                </div>

                {hasGroup() ? (
                  <div
                    className={`m-support-g-tabs__col1__moderator__bio__container__msg hide-on-mobile`}
                    onMouseLeave={() => {
                      setIsMsgExpanded(false);
                    }}
                  >
                    <div
                      className={`m-support-g-tabs__col1__moderator__bio__container__msg__icon ${
                        isMsgExpanded ? "expanded" : ""
                      }`}
                      onMouseEnter={() => setIsMsgExpanded(true)}
                    >
                      <i className="icon-envelope1"></i>
                    </div>
                    <div className="m-support-g-tabs__col1__moderator__bio__container__msg__txt">
                      <a
                        href={
                          data?.referenciaTabsContenido[activeTab]
                            ?.referenciaCursosDestacados[0]?.redireccionBoton
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`${
                          isMsgExpanded ? "seen" : ""
                        } gtmInternaGruposApoyoDejarMensaje`}
                      >
                        DÉJAME UN MENSAJE
                      </a>
                    </div>
                  </div>
                ) : null}
                {hasGroup() ? (
                  <div
                    className={`m-support-g-tabs__col1__moderator__bio__container__msg show-on-mobile`}
                    onMouseLeave={() => {
                      setIsMsgExpanded(false);
                    }}
                  >
                    <div
                      className={`m-support-g-tabs__col1__moderator__bio__container__msg__icon expanded`}
                      onMouseEnter={() => setIsMsgExpanded(true)}
                    >
                      <i className="icon-envelope1"></i>
                    </div>
                    <div className="m-support-g-tabs__col1__moderator__bio__container__msg__txt">
                      <a
                        href={
                          data?.referenciaTabsContenido[activeTab]
                            ?.referenciaCursosDestacados[0]?.redireccionBoton
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        className={"seen gtmInternaGruposApoyoDejarMensaje"}
                      >
                        DÉJAME UN MENSAJE
                      </a>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
        <div className="m-support-g-tabs__col2">
          {renderSchedule()}
          <div className="m-support-g-tabs__col2__info">
            <div className="location-icon group-icon"></div>
            <div className="m-support-g-tabs__col2__info__text">
              <h3>{getDescripcionEventos(1)?.content[0]?.content[0]?.value}</h3>
              <p>{getDescripcionEventos(1)?.content[0]?.content[1]?.value}</p>
            </div>
          </div>
          <div className="m-support-g-tabs__col2__info">
            <i className="icon-user1"></i>
            <div className="m-support-g-tabs__col2__info__text">
              <h3>{getDescripcionEventos(2)?.content[0]?.content[0]?.value}</h3>
              <p>{getDescripcionEventos(2)?.content[0]?.content[1]?.value}</p>
            </div>
          </div>
          <div className="m-support-g-tabs__col2__info">
            <i className="icon-envelope1"></i>
            <div className="m-support-g-tabs__col2__info__text">
              <h3>{getDescripcionEventos(3)?.content[0]?.content[0]?.value}</h3>
              <p>{getDescripcionEventos(3)?.content[0]?.content[1]?.value}</p>
            </div>
          </div>
          <div className="m-support-g-tabs__col2__btn">
            <Button
              text={"Unirme al grupo"}
              classname={"a-button secondary"}
              type={"button"}
              isDisabled={false}
              strictCss={false}
              // gtmMark={"gtmInternaGruposApoyoUnirme"}
              onClickAction={() => goToShop()}
            />
          </div>
        </div>
      </div>
      {hasGroup() ? (
        <form
          method="POST"
          action="https://comfama.webex.com/comfama/m.php"
          target="_blank"
        >
          <input type="hidden" name="AT" value="JM" />
          <input
            type="hidden"
            name="MK"
            value={userGroupData[0]?.meetingNumber || ""}
          />
          <input
            type="hidden"
            name="PW"
            value={atob(userGroupData[0]?.meetingPassword)}
          />
          <input
            type="hidden"
            name="AN"
            value={userGroupData[0]?.customerFullName}
          />
          <input
            type="hidden"
            name="AE"
            value={userGroupData[0]?.customerEmail}
          />
          <input type="hidden" name="CO" value={""} />
          <input type="hidden" name="MC" value={""} />
          <input
            type="hidden"
            name="BU"
            value="https://dnsnz91tx0zxq.cloudfront.net/"
          />
          <input
            type="submit"
            name="B1"
            className="hidenn-btn"
            ref={refBtn}
            value={"Submit"}
          />
        </form>
      ) : null}
    </div>
  );
};

export default SupportGroupTabs;
